import { Action } from 'redux';
import { InsuranceInfoStateStructure } from '../../angular-elements/shared/interfaces/insuranceInfoStateStructure.interface';

export class PayloadAction implements Action {
  type: string;
  insuranceInfoStateStructure?: InsuranceInfoStateStructure;
}

const INITIAL_STATE: InsuranceInfoStateStructure = {
  benefitsFromMedicaid: '',
  companyName: '',
  companyProvidingCoverage: '',
  coverageFromOtherMedicarePlan: '',
  coverageRxMedicare: '',
  coverageUnderOtherInsurance: '',
  currentMonthlyPremium: '',
  currentRateTier: '',
  dropMedicareSupplementPolicy: '',
  endDate: '',
  firstTimeMedicarePlan: '',
  hasAnotherMedicareSupplementPolicy: '',
  highmarkID: '',
  intendToReplaceCoverage: '',
  intendToReplaceCurrentMedicare: '',
  nameOfCompany: '',
  nameOfPlan: '',
  otherPolicyCoverageEndDate: null,
  otherPolicyCoverageStartDate: null,
  policyType: '',
  startDate: '',
  stateMedicaid: '',
  willMedicaidPayPremiums: '',
  doesMedicaidPayMedicarePremium: '',
  doesMedicaidPayMedigapPremium: ''
};

export const LOAD_INSURANCE_INFO = 'LOAD_INSURANCE_INFO';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
const RESET_STATE = 'RESET_STATE_InsuranceInfo';

export function loadInsuranceInfo(info: InsuranceInfoStateStructure): PayloadAction {
  return {
    type: LOAD_INSURANCE_INFO,
    insuranceInfoStateStructure: info
  };
}

export function resetInsuranceInfo(): PayloadAction {
  return { type: RESET_STATE };
}

export function insuranceInfo( state: InsuranceInfoStateStructure = INITIAL_STATE, action: PayloadAction ) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case LOAD_INSURANCE_INFO:
      copiedState.benefitsFromMedicaid = action.insuranceInfoStateStructure.benefitsFromMedicaid;
      copiedState.companyName = action.insuranceInfoStateStructure.companyName;
      copiedState.companyProvidingCoverage = action.insuranceInfoStateStructure.companyProvidingCoverage;
      copiedState.coverageFromOtherMedicarePlan = action.insuranceInfoStateStructure.coverageFromOtherMedicarePlan;
      copiedState.coverageRxMedicare = action.insuranceInfoStateStructure.coverageRxMedicare;
      copiedState.coverageUnderOtherInsurance = action.insuranceInfoStateStructure.coverageUnderOtherInsurance;
      copiedState.currentMonthlyPremium = action.insuranceInfoStateStructure.currentMonthlyPremium;
      copiedState.currentRateTier = action.insuranceInfoStateStructure.currentRateTier;
      copiedState.dropMedicareSupplementPolicy = action.insuranceInfoStateStructure.dropMedicareSupplementPolicy;
      copiedState.endDate = action.insuranceInfoStateStructure.endDate;
      copiedState.firstTimeMedicarePlan = action.insuranceInfoStateStructure.firstTimeMedicarePlan;
      copiedState.hasAnotherMedicareSupplementPolicy = action.insuranceInfoStateStructure.hasAnotherMedicareSupplementPolicy;
      copiedState.highmarkID = action.insuranceInfoStateStructure.highmarkID;
      copiedState.intendToReplaceCoverage = action.insuranceInfoStateStructure.intendToReplaceCoverage;
      copiedState.intendToReplaceCurrentMedicare = action.insuranceInfoStateStructure.intendToReplaceCurrentMedicare;
      copiedState.nameOfCompany = action.insuranceInfoStateStructure.nameOfCompany;
      copiedState.nameOfPlan = action.insuranceInfoStateStructure.nameOfPlan;
      copiedState.otherPolicyCoverageEndDate = action.insuranceInfoStateStructure.otherPolicyCoverageEndDate;
      copiedState.otherPolicyCoverageStartDate = action.insuranceInfoStateStructure.otherPolicyCoverageStartDate;
      copiedState.policyType = action.insuranceInfoStateStructure.policyType;
      copiedState.startDate = action.insuranceInfoStateStructure.startDate;
      copiedState.stateMedicaid = action.insuranceInfoStateStructure.stateMedicaid;
      copiedState.willMedicaidPayPremiums = action.insuranceInfoStateStructure.willMedicaidPayPremiums;
      copiedState.doesMedicaidPayMedicarePremium = action.insuranceInfoStateStructure.doesMedicaidPayMedicarePremium;
      copiedState.doesMedicaidPayMedigapPremium = action.insuranceInfoStateStructure.doesMedicaidPayMedigapPremium;
      return Object.assign({}, state, copiedState);
    case INIT_PAYLOAD:
    case RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
}

